import applicationRouter from "../../../hoc/applicationRouter";
import withLocalization from "../../../hoc/withLocalization";
import { getAverageHoursColor } from '~/utils/rosterMethods';

const cycleDetails = ({ cycleTotalsSummary, cycleTotals, mandatory_overtime_limit_per_week, workHoursRuleByDepartment, selectedWeek, handleWeekNavigation, t }) => {


    return (
        <>
            <div className="weekly-shift-cycle-data-container">
                <div className="d-flex justify-content-start align-items-center p-2 weekly-shift-cycle-data-header">
                    <span className="fw-bold fs14">{t('Cycle')} {t('Details')}</span>
                </div>
                <div className="weekly-shift-cycle-data-body">
                    <div className="d-flex flex-column gap-1">
                        <div className="d-flex justify-content-between">
                            <span className="text-muted">{t('Assigned')} {t('shifts')}: </span>
                            <span className="fw-bold">{cycleTotalsSummary.totalShifts || '-'}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                            <span className="text-muted">{t('Assigned')} {t('Hours')}:</span>
                            <span className="fw-bold">{cycleTotalsSummary.totalHours || '-'}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                            <span className="text-muted">{t('Avg.')} {t('weekly')} {t('hr')}:</span>
                            <span className={`fw-bold ${getAverageHoursColor(cycleTotalsSummary.averageHours, workHoursRuleByDepartment)}`}>
                                {cycleTotalsSummary.averageHours || '-'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="weekly-shift-weeks-container">
                <div className="d-flex justify-content-start align-items-center p-2 weekly-shift-weeks-header">
                    <span className="fw-bold fs15">
                        {t('Cycle Weeks')} ({cycleTotalsSummary.totalWeeks} {t('Weeks')})
                    </span>
                </div>
                <div className="weekly-shift-weeks-body">
                    <div className="d-flex flex-column gap-2">
                        {cycleTotals.map(weekTotal => (
                            <button
                                key={`Cycle week-${weekTotal.week}`}
                                className={`weekly-shift-week-navigation-btn ${weekTotal.totalHours * 60 > mandatory_overtime_limit_per_week ? 'text-danger' : 'text-primary-color'}`}
                                onClick={() => handleWeekNavigation(weekTotal.week)}
                            >
                                <span
                                    className={`fw-600 fs12 
                                        ${weekTotal.totalHours * 60 > mandatory_overtime_limit_per_week ? 'text-danger' : weekTotal.week == selectedWeek.week ? 'text-light' : 'text-primary-color'}
                                        ${weekTotal.week == selectedWeek.week ? 'active-bg' : ''}`}
                                >
                                    <span className="fw-600 fs14"> {t('Week')} {weekTotal.week} </span>
                                    {weekTotal.shiftCount === 0 ? ' (-/-)' : ` (${weekTotal.totalHours}${t('hr')}/${weekTotal.shiftCount} ${t('shifts')})`}
                                </span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}
export default withLocalization(applicationRouter(cycleDetails));
